import * as React from "react";

export const BorderRightSVG = (props) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="2" transform="matrix(-1 0 0 1 16 0)" fill="white"/>
    <rect x="-0.75" y="0.75" width="14.5" height="14.5" rx="1.25" transform="matrix(-1 0 0 1 14.5 0)" stroke="#7D8492" stroke-opacity="0.3" stroke-width="1.5"/>
    <mask id="path-3-inside-1_3872_5261" fill="white">
    <path d="M16 2C16 0.895431 15.1046 0 14 0H2C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2Z"/>
    </mask>
    <path d="M16 0H0H16ZM0 16H16H0ZM14 16C15.933 16 17.5 14.433 17.5 12.5V3.5C17.5 1.567 15.933 0 14 0C14.2761 0 14.5 0.895431 14.5 2V14C14.5 15.1046 14.2761 16 14 16ZM0 0V16V0Z" fill={`${props.color ? props.color : "#052f35 "}`} mask="url(#path-3-inside-1_3872_5261)"/>
    </svg>
      
);
